import * as React from "react"
import styled from "styled-components"
import { colors, scale } from "../../styles"
import { Flex } from "../Flex"
import { Icon } from "../Icon"
import { Text } from "../Text"
import { FieldError, FieldErrorsImpl, Merge } from 'react-hook-form'

export interface SwitchProps {
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => any
    disabled?: boolean
    id?: string
    name?: string
    value?: string
    checked?: boolean
    label?: React.ReactNode
    inputRef?: React.Ref<any>
    helperText?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>>
    error?: FieldError | Merge<FieldError, FieldErrorsImpl<any>>
    defaultChecked?: boolean
}

interface LabelStyledProps {
    disabled?: boolean
}

const LabelStyled = styled.label<LabelStyledProps>`
	position: relative;
	display: inline-flex;
    flex-direction: row-reverse;
	cursor: pointer;
	font-size: ${scale.px(2)};
	line-height: ${scale.px(3)};
	color: ${colors.navy};
	user-select: none;
    column-gap: ${scale.px(1)};
`

const ControlStyled = styled.div<{ disabled?: boolean }>`
 position: relative;
    min-width: ${scale.px(7)};
    height: ${scale.px(4)};
    border: 1px solid grey;
    border-radius: 16px;
    background-color: ${colors.greyF3};
    transition: background-color .2s ease-in-out;

    &:after {
        content: '';
        position: absolute;
        left: 4px;
        top: 3px;
        background-color: ${colors.navy};
        border-radius: 50%;
        width: ${scale.px(3)};
        height: ${scale.px(3)};
        transform: translateX(0);       
        transition: transform 0.4s cubic-bezier(0.4, 0.0, 0.2, 1), 
        background-color 0.2s ease-in-out;
    }
`

const InputStyled = styled.input.attrs({ type: "checkbox" })`
    position: absolute;
    left: -9999px;

    &:checked {
       

        &+.switch__control {
            background-color: ${colors.navy};
            
            
            
            &:after {
                transform: translateX(22px);
                background-color: ${colors.white};
            }
        }

        &~.switch__label {
            color: green;

           
        }
    }

    &:focus~.switch__control {
        outline: 4px auto #4D90FE;
    }
`

const Switch: React.FC<SwitchProps> = (props) => {
    const { helperText, error, label, id, disabled, inputRef, ...rest } = props

    return (
        <Flex>
            <LabelStyled disabled={disabled} htmlFor={id}>
                <InputStyled ref={inputRef} id={id} disabled={disabled} {...rest} />
                <ControlStyled className="switch__control" />
                <Flex alignItems='center'>{label}</Flex>
            </LabelStyled>
            {helperText && (
                <Flex pr={4} w={1} minh={helperText ? "none" : 3}>
                    <Text
                        as="span"
                        textColor={error ? "alert" : "navy"}
                        fontSize={1.75}
                        lineHeight={2.5}
                        mt={0.5}
                        mb={0}
                    >
                        <>
                            {helperText}
                        </>
                    </Text>
                </Flex>
            )}
        </Flex>
    )
}

export { Switch }
